<div class="w-100 me-3">
  @if (!hideLabel) {
    <label class="form-text">
      {{ label || ('general.users' | translate) }}
    </label>
  }
  <nz-select
    data-test-id="wilson-users-select:select"
    [required]="isRequired"
    [nzPlaceHolder]="'general.users' | translate"
    nzShowSearch
    nzAllowClear
    [disabled]="isDisabled"
    [ngModel]="selectedUserId"
    (ngModelChange)="updateSelectedUserId($event)"
  >
    @for (user of userOptions$ | async; track user) {
      <nz-option
        [nzValue]="user.userId"
        [nzLabel]="user.user.lastName + ', ' + user.user.firstName"
        [nzHide]="isSelected(user.id)"
      >
      </nz-option>
    }
  </nz-select>
</div>
